import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { Anchor } from '../anchor';
import { carouselSkipLinkStyles } from './styles/carousel-skip-link.styles';
import type { CarouselSkipLinkPropsInterface } from './types/carousel-skip-link.types';

export const CarouselSkipLink = forwardRef<HTMLAnchorElement, CarouselSkipLinkPropsInterface>(
  (props: CarouselSkipLinkPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;

    const styles = css(carouselSkipLinkStyles, cssProp);

    return (
      <Anchor
        ref={forwardedRef}
        href="#"
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Carousel.SkipLink"
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {children}
      </Anchor>
    );
  },
);
